import {collection, component, EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {ProductLineReferenceData} from "../product-line/product-line-reference.data";

export class ExtraReferenceData extends LocalisableEntityData<ExtraReferenceData> {
    @identifier id: number;
    @field name: string;
}

export class ExtraTieredPriceData extends EntityData<ExtraTieredPriceData> {
    @field qty: number;
    @field price: number;
}

export class ExtraProductData extends EntityData<ExtraProductData> {
    @field price: number;
    @field userPrompt: string;
    @field defaultOrderQty: number;
    @field qtyLimit: number;
    @field mixAndMatchDiscountable: boolean = false;
    @field includeNestedExtras: boolean = false;
    @component productLine: ProductLineReferenceData;
}

export class ExtraData extends LocalisableEntityData<ExtraData> {
    @identifier id: number;
    @field name: string;
    @field externalName: string;
    @field selectionMessage: string;
    @field promoted: boolean;
    @field promotionMessage: string;
    @field conversational: boolean;
    @field totalIncluded: number;
    @field displayDefaults: boolean = true;
    @field groupQtyMin: number;
    @field groupQtyLimit: number;

    @collection(ExtraProductData) extraProducts: ExtraProductData[];
    @collection(ExtraTieredPriceData) extraTieredPrices: ExtraTieredPriceData[];
}
